import { render } from "./createWorkerDialog.vue?vue&type=template&id=5ffdbf82&scoped=true"
import script from "./createWorkerDialog.vue?vue&type=script&lang=js"
export * from "./createWorkerDialog.vue?vue&type=script&lang=js"

import "./createWorkerDialog.vue?vue&type=style&index=0&id=5ffdbf82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffdbf82"]])

export default __exports__